import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {FormattedMessage, intlShape} from 'react-intl'
import * as shapes from '../../constant/shapes'

import * as selectors from './trackListSelectors'
import * as playerSelectors from '../miniPlayer/miniPlayerSelectors'
import cx from 'classnames'

import TrackItem from './TrackItem'
import {ORIGIN_PLAYQUEUE_TYPES} from '../miniPlayer/AudioPlayer/playerConstants'
import appConst from '../../constant/appConst'
import GTMController from "../../utils/kpi/GTMController"
import {open as openAction} from "../miniPlayer/miniPlayerActions"
import {pause as pauseAction, play as playAction} from "../miniPlayer/AudioPlayer/playerActions"
import {notify as notifyAction} from "../notifier/NotifierActions"
import {notificationMessage} from "../miniPlayer/MiniPlayer"
import {Link} from "react-router"
import {sortByWorks} from "../../utils/filters"

class TrackList extends Component {

	onClick = (track, isDoubleClick) => {
		const isMobile = mobilecheck()
		if ((isMobile && isDoubleClick) || (!isMobile && !isDoubleClick)) {
			return false
		}
		const {playing, isCurrentTrack, GTMPlayEvent, play, open, pause, notify} = this.props
		const {intl} = this.context
		const type = ORIGIN_PLAYQUEUE_TYPES.track
		if (track.sampleable) {
			if (isCurrentTrack(type, track.id)) {
				if (playing) {
					pause()
				} else {
					play()
				}
			} else {
				GTMController.pushPlayEvent(GTMPlayEvent)
				open(track, type)
			}
		} else {
			notify({
				message: <div className="notification-content">{notificationMessage(track.id, intl)}</div>,
				level: 'info',
				autoDismiss: 5
			})
		}
	}

	render = () => {
		const {
			fields,
			discList,
			listContainerClassName,
			listClassName,
			moreItemsCallback,
			offset,
			total,
			mediaCount,
			playing,
			isCurrentTrack,
			GTMPlayEvent,
			displayWork
		} = this.props
		const {intl} = this.context

		if (total === 0) {
			return (
				<div className="tracklist__empty pct pct-disc">
					<p className="tracklist__message">{intl.formatMessage({id: 'tracklist.noTracks'})}</p>
				</div>
			)
		}

		return (
			<div>
				{discList.map((disc, keyDisc) => {
					const works = displayWork ? sortByWorks(disc) : [{name: undefined, tracks: disc}]
					return (
						<div className={listContainerClassName} key={`tracks-list-${keyDisc}`}>
							{mediaCount > 1 && (
								<span className="tracklist__label">
									<FormattedMessage id="tracklist.media_count" values={{mediaNumber: keyDisc}}/>
								</span>
							)}
							{works.map((work, workIndex) => {
								const workTracks = work.tracks
								return (
									<div key={`discWork-${workIndex}`}>
										{work.name &&
											<p className="tracklist__work">{work.name}
												{workTracks[0].composer && workTracks[0].composer.name && [' (',
												<Link className="tracklist__work tracklist__work--link" to={`/artist/${workTracks[0].composer.id}`}>{workTracks[0].composer.name}</Link>, ')']}
											</p>
										}
										<ul className={listClassName}>
											<li className="track track--header">
												<div className="track__items">
													{fields.map((field, key) => (
														<span className={`track__item track__item--${field.type}`} key={`table-header-${key}`}>
															{field.type !== 'cover' &&
																intl.formatMessage({id: `tracklist.header.${field.type}`}) || ' '}
														</span>
													))}
												</div>
											</li>
											{workTracks.map((track, trackKey) => {
												const isCurrent = isCurrentTrack(ORIGIN_PLAYQUEUE_TYPES.track, track.id)
												return (
													<li
														className={cx(["track", {isPlaying: isCurrent && playing}, {isPause: isCurrent && !playing}])}
														key={`table-row-${trackKey}`}
														onDoubleClick={() => this.onClick(track, true)}
														onClick={() => this.onClick(track, false)}
														{
															...(isCurrentTrack(ORIGIN_PLAYQUEUE_TYPES.track, track.id)
																&& {className: `track isPlaying ${!playing && 'isPause'}`})
														}
													>
														<TrackItem track={track} fields={fields} index={trackKey} GTMPlayEvent={GTMPlayEvent}/>
													</li>
												)
											})}
										</ul>
									</div>
								)
							})}
						</div>
					)
				})}
				{moreItemsCallback && offset + appConst.trackListLoadStep < total &&
				<button
					onClick={moreItemsCallback}
					className="tracklist__button pct pct-add">{intl.formatMessage({id: 'buttons.showmore'})}
				</button>
				}
			</div>
		)
	}
}

TrackList.propTypes = {
	discList: PropTypes.arrayOf(PropTypes.arrayOf(shapes.trackItem)),
	fields: PropTypes.arrayOf(PropTypes.shape({
		type: PropTypes.string,
		render: PropTypes.func
	})).isRequired,
	listContainerClassName: PropTypes.string,
	listClassName: PropTypes.string,
	moreItemsCallback: PropTypes.func,
	offset: PropTypes.number,
	total: PropTypes.number,
	mediaCount: PropTypes.number,
	idPlaying: PropTypes.number,
	playing: PropTypes.bool,
	GTMPlayEvent: PropTypes.string,
	displayWork: PropTypes.bool,
	isCurrentTrack: PropTypes.func,
	notify: PropTypes.func
}

TrackList.contextTypes = {
	intl: intlShape
}

const mapStateToProps = state => ({
	discList: selectors.getTrackListItemsByMediaNumber(state),
	offset: selectors.getTrackListOffset(state),
	total: selectors.getTrackListTotal(state),
	mediaCount: selectors.getMediaCount(state),
	idPlaying: (playerSelectors.getIdCurrentTrack(state)),
	playing: playerSelectors.isPlaying(state),
	isCurrentTrack: (type, idElement) => playerSelectors.isCurrentTrack(state)(type, idElement)
})

const actions = {
	open: openAction,
	play: playAction,
	pause: pauseAction,
	notify: notifyAction
}

export default connect(mapStateToProps, actions)(TrackList)



// WEBPACK FOOTER //
// ./src/components/tracklist/TrackList.jsx